require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-middle-park-vogue-living-terrace.json") })
        }
      }, "path---journal-middle-park-vogue-living-terrace");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-middle-park-vogue-living-terrace!./.cache/json/journal-middle-park-vogue-living-terrace.json
// module id = 515
// module chunks = 231608221292675